module.exports = __webpack_public_path__ + "static/media/logo_communication.51b06b5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_communication.png
// module id = 596
// module chunks = 0